import * as React from 'react'
import { requestWpsData } from '../../utils/requestWpsData'
import { Args, getWidgetProps, Widget, withArgs, WPSClient } from 'DVWebNodeUtils'
import { StringBundle } from '../../components/localizer/localizer'
import { Provider } from 'react-redux'
import { AtfComponent } from './component'
import {
  normalizeGetStrings,
  normalizeGetPreferences,
  normalizeGetDetailPage,
  normalizeOfferAvailableOn,
  normalizeFormattedOfferAvailableOn,
  NormalizeGetDetailPageType,
  NormalizeGetStringsType,
  NormalizeGetPreferencesType
} from '../../data/normalize'
import { configureStore } from '../../store'
import { IDetailPageState } from '../../reducers'
import { safeBoolean } from '../../utils/utils'
import { ErrorBoundary } from '../../components/error/ErrorBoundary'
import { GetAtfInput, getAtfInput } from '../../data/getDetailPageInputs'

export type AtfProps = {
  state: NormalizeGetDetailPageType &
    NormalizeGetStringsType &
    NormalizeGetPreferencesType &
    Pick<IDetailPageState, 'features'>
  isPageChange?: boolean
}

export const getProps: getWidgetProps<AtfProps> = async ({ context, titleID, isCrow, useMFA, formattedOfferAvailableOn, offerAvailableOn,
                                                           usePlayer, amabotContext, isElcano, useNodeGiftCard, useNodeDeeplinking, useNewHover, atfTreatment }, api) => {

  const operation = (wpsClient: WPSClient) => {
    let args: GetAtfInput = { context, titleID, isCrow: safeBoolean(isCrow), isElcano: safeBoolean(isElcano) }

    if (amabotContext) {
      args = { ...args, amabotContext }
    }

    return wpsClient.GetDetailPage(getAtfInput(args))
  }

  const wpsData = await requestWpsData({
    context,
    api,
    operation,
    stringBundle: StringBundle.ATF,
    requestPreferences: true
  })

  return {
    state: {
      features: {
        useMFA: safeBoolean(useMFA),
        usePlayer: safeBoolean(usePlayer),
        isElcano: safeBoolean(isElcano),
        useNodeGiftCard: safeBoolean(useNodeGiftCard),
        useNodeDeeplinking: safeBoolean(useNodeDeeplinking),
        useNewHover: safeBoolean(useNewHover),
        atfTreatment: atfTreatment
      },
      ...normalizeOfferAvailableOn(titleID, offerAvailableOn),
      ...normalizeFormattedOfferAvailableOn(titleID, formattedOfferAvailableOn),
      ...normalizeGetStrings(wpsData.stringsResponse!),
      ...normalizeGetPreferences(wpsData.preferencesResponse!),
      ...normalizeGetDetailPage(titleID, wpsData.operationResponse)
    }
  }
}

const AtfWidget = (props: AtfProps & Args) => {
  const { logger, context: requestContext, state, isPageChange } = props
  const store = configureStore({ ...state, requestContext }, logger, isPageChange)

  return (
    <Provider store={store}>
      <ErrorBoundary name="atf">
        <AtfComponent />
      </ErrorBoundary>
    </Provider>
  )
}

export const Atf: Widget<AtfProps> = {
  name: 'detail-atf',
  getProps: global.__SERVER__ === true ? getProps : undefined,
  Component: withArgs(AtfWidget) as React.ComponentType<any>
}
